// hooks/useAccessibilitySetup.ts
import { useEffect } from "react";

const IGNORE_CLASSES = ["ql-bold", "ql-italic", "ql-list"];
const FOCUSABLE_CLASSES = ["focusable", "ql-editor"];

export const useAccessibilitySetup = (): void => {
	useEffect(() => {
		const updateTabIndexes = (): void => {
			const elements = document.querySelectorAll<HTMLElement>("*");

			elements.forEach((element) => {
				// Enable tabs for focusable elements
				if (FOCUSABLE_CLASSES.some((cls) => element.classList.contains(cls))) {
					element.setAttribute("tabIndex", "0");
					return;
				}

				// Handle input elements
				if (element instanceof HTMLInputElement) {
					element.setAttribute("tabIndex", "0");
					return;
				}

				// Handle button elements
				if (element instanceof HTMLButtonElement) {
					const shouldIgnore = IGNORE_CLASSES.some((cls) =>
						element.classList.contains(cls)
					);
					element.setAttribute("tabIndex", shouldIgnore ? "-1" : "0");
					return;
				}

				// Default to non-focusable
				element.setAttribute("tabIndex", "-1");
			});
		};

		// Initial update
		updateTabIndexes();

		// Observe DOM changes
		const observer = new MutationObserver(updateTabIndexes);
		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});

		return () => {
			observer.disconnect();
		};
	}, []);
};
